import axios from 'axios';

export const getDeviceThermocouplesService = async (deviceId) => {
  const response = await axios.get(`/thermocouples?deviceId=${deviceId}`);
  return response.data?.data;
};

/**
 * PATCH /thermocouples/{deviceId}: force a thermocouple.
 * @param {string} deviceId
 * @param {{tc_no: number, fault_mode: 1|2|3, deviceType: 'ESS'|'TGS'|'TES'}} data
 *   fault_mode 1 = max heat 12 h, 2 = max heat 3 days, 3 = system off
 * @returns {Promise<*>}
 */

export const updateDeviceThermocoupleService = async (deviceId, data) => {
  const response = await axios.patch(`/thermocouples/${deviceId}`, data);
  return response.data?.data;
};

/**
 * POST /attends: log an action taken on a fault.
 * @param {import('../helpers/payloads/attendPayload').AttendPayload} attendData
 * @returns {Promise<*>}
 */

export const FaultAttendService = async (attendData) => {
  const response = await axios.post('/attends', attendData);
  return response.data;
};

/**
 * GET /attends. Unenveloped reply.
 * @param {string} fault_type  from `faultAttendKey`
 * @param {number} fault_index  from `faultAttendIndex`
 * @param {string} device_id
 * @returns {Promise<{attends: Array<Object>}>}
 */

export const getFaultAttendService = async (fault_type, fault_index, device_id) => {
  const response = await axios.get(
    `/attends?fault_type=${fault_type}&fault_index=${fault_index}&device_id=${device_id}`,
  );
  return response.data;
};
